/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { EngProgClass } from './eng-prog-class.model';
import { ForecastState } from './forecast-state.model';
import { IndustryScenario } from './industry-scenario-dto.model';
import {PropulsionScenario} from './propulsion-scenario-dto-model';
import { PropulsionType } from './propulsion-type.model';

/**
 * Model to represent a VehicleScenarioDTO from the API.
 * Contains attributes from the VehicleScenario table.
 *
 */
export class VehicleScenario {
  vehScenId: number;
  portType: string;
  vehScenName: string;
  vehScenAsmptn: string;
  sgmntSchmDflt: string;
  scenCat: string;
  scenType: string;
  industryScenario: IndustryScenario;
  propulsionScenario: PropulsionScenario;
  fcorg: string;
  isEditLocked: boolean;
  isDeleteLocked: boolean;
  createdById: string;
  tstamp: string;
  isHidden: boolean;
  bdgtYr: number;
  bpPub: string;
  propulsionType: PropulsionType;
  engProgClass: EngProgClass;
  forecastState: ForecastState;
  createdBy: string;
}
